import http from '@/lib/http'
import { isUserTrialPrescriber } from '@/lib/permissions'
import { queryClient } from '@/services/queryClient'
import { useMutation } from '@tanstack/react-query'

interface PostReplyPayload {
  conversationId: string
  message: string
  medRequestId: string
}

export default function usePostReplyToConversation() {
  const isTrialPrescriber = isUserTrialPrescriber()

  return useMutation({
    mutationFn: (payload: PostReplyPayload) =>
      isTrialPrescriber
        ? Promise.resolve(null)
        : http.post(`/prescriber/med-requests/conversations/${payload.conversationId}`, {
            message: payload.message,
            medRequestId: payload.medRequestId
          }),
    onSuccess: (data, variables) => {
      queryClient.setQueryData(['getConversationById', variables.conversationId], data)
      queryClient.invalidateQueries({
        queryKey: ['medicationRequestById', variables.medRequestId]
      })
    }
  })
}
